<nav class="navbar navbar-light bg-light fixed-top">
    <div>
        @if (isRequestsRoute()) {
            <button class="navbar-toggler" type="button" (click)="toggleSidebar()">
                <span class="navbar-toggler-icon"></span>
            </button>
        }
        @if (isRequestsRoute() && initializationService.portal && portals.length === 1) {
            <div class="portal-dropdown-menu ms-2">
                <div class="portals-button">
                    @if (initializationService.portal.logoUrl) {
                        <img
                            [src]="initializationService.portal.logoUrl"
                            [alt]="initializationService.portal.name"
                            style="max-height: 30px; max-width: 80px" />
                    }
                    @if (!initializationService.portal.logoUrl) {
                        <span>{{ initializationService.portal.name }}</span>
                    }
                </div>
            </div>
        }
        @if (isRequestsRoute() && initializationService.portal && portals.length >= 2) {
            <div dropdown class="portal-dropdown-menu ms-2" placement="bottom">
                <div id="portals-button" class="portals-button pointer" dropdownToggle aria-controls="portals-dropdown">
                    @if (initializationService.portal.logoUrl) {
                        <img
                            [src]="initializationService.portal.logoUrl"
                            [alt]="initializationService.portal.name"
                            style="max-height: 30px; max-width: 80px" />
                    }
                    @if (!initializationService.portal.logoUrl) {
                        <span>
                            {{ initializationService.portal.name }}
                        </span>
                    }
                    <sb-inline-svg
                        class="icon"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/drop-down-arrow.svg'">
                    </sb-inline-svg>
                </div>
                <ul
                    id="portals-dropdown"
                    *dropdownMenu
                    class="dropdown-menu"
                    role="menu"
                    aria-labelledby="portals-button">
                    @for (portal of portals; track portal) {
                        <li (click)="goToPortal(portal.name)" class="dropdown-item" role="menuitem">
                            <div class="portal-logo">
                                @if (portal.logoUrl) {
                                    <img class="portal-logo-img" src="{{ portal.logoUrl }}" />
                                }
                            </div>
                            <div class="portal-name">
                                {{ portal.name }}
                            </div>
                        </li>
                    }
                </ul>
            </div>
        }
    </div>
    @if (isRequestsRoute()) {
        <form class="form-inline my-0">
            <div class="input-group wrapper-for-input-with-clear-button">
                <label for="query-control" class="input-group-text mb-0">
                    <i class="fa fa-search"></i>
                </label>
                <input
                    id="query-control"
                    type="text"
                    [value]="query"
                    [formControl]="queryControl"
                    class="form-control"
                    style="border-radius: 0 0.25rem 0.25rem 0 !important"
                    placeholder="{{ 'Search for request and internal ID`s' | translate }}" />
                @if (query.length >= 1) {
                    <button type="button" (click)="clearSearchInput()" class="clear-button">
                        <i class="fa fa-times"></i>
                    </button>
                }
            </div>
        </form>
    }
    <sb-settings-menu
        [user]="user"
        [communityName]="communityName"
        [customerSettings]="{}"
        [language]="commonDataService.language"
        (logout)="authenticationService.logOff()">
    </sb-settings-menu>
</nav>
